exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui-datatable .ui-datatable-data > tr:nth-child(even) {background-color: rgba(200, 200, 200, 0.4);}\n.ui-datatable .ui-datatable-data > tr:hover {background-color: rgba(250, 250, 250, 0.4);}\n\n.ui-datatable .ui-datatable-thead > tr > th {\n\tborder: none!important;\n    background-color: white!important;\n    text-align: center!important;\n    border-bottom: 1px solid #ddd!important;\n}\n\n.ui-widget input {\n\tborder: 1px solid rgba(200, 200, 200, 0.4);\n}\n\n.ui-datatable th.ui-sortable-column:not(.ui-state-active):hover, .ui-datatable th.ui-sortable-column:not(.ui-state-active):focus {\n\tbackground-color: white!important;\n\tcolor: initial!important;\n}\n\n.ui-datatable .ui-datatable-thead>tr>th, .ui-datatable .ui-datatable-tfoot>tr>td, .ui-datatable .ui-datatable-data>tr>td {\n\tborder: none!important;\n    padding: 15px!important;\n}\n\n.ui-datatable th.ui-state-active {\n\tcolor: #212121!important;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/src/app/results/results.component.css
// module id = ../../../../../src/app/results/results.component.css
// module chunks = 0